import * as React from 'react';
import { useIntl } from 'react-intl';

import { PictogramRegularDiamond } from '@notino/react-styleguide';

import { useIsDesktop } from '@utils/helpers';

import {
  STANDARD_MODAL_IMAGE_PATH,
  RETINA_MODAL_IMAGE_PATH,
  MOBILE_MODAL_IMAGE_PATH,
} from '../../constants';

import { messages } from './messages';
import {
  ModalHeader,
  ModalContent,
  TextContentWrapper,
  DiamondIconWrapper,
  InfoWrapper,
  ContentWrapper,
  ImageWrapper,
  StyledImagePlaceholder,
} from './styled';

interface IBaseLoyaltyModalProps {
  headerMessage: string;
  children: JSX.Element;
  footerContent: JSX.Element;
  hideImageOnMobile?: boolean;
}

export const BaseLoyaltyModal: React.FC<IBaseLoyaltyModalProps> = ({
  headerMessage,
  children,
  footerContent,
  hideImageOnMobile,
}) => {
  const { formatMessage } = useIntl();
  const isDesktop = useIsDesktop();

  return (
    <ModalContent data-testid="benefits-modal">
      <ContentWrapper>
        <TextContentWrapper>
          <DiamondIconWrapper>
            <PictogramRegularDiamond width="2.5rem" height="2.5rem" />
          </DiamondIconWrapper>
          <InfoWrapper>
            <ModalHeader>{headerMessage}</ModalHeader>
            {children}
          </InfoWrapper>
        </TextContentWrapper>
        {footerContent}
      </ContentWrapper>
      <ImageWrapper hideOnMobile={hideImageOnMobile}>
        <StyledImagePlaceholder
          image={{
            srcSet: isDesktop
              ? `${STANDARD_MODAL_IMAGE_PATH} 1x, ${RETINA_MODAL_IMAGE_PATH} 2x`
              : `${MOBILE_MODAL_IMAGE_PATH}`,
            src: isDesktop
              ? STANDARD_MODAL_IMAGE_PATH
              : MOBILE_MODAL_IMAGE_PATH,
            alt: formatMessage(messages.imgAlt),
          }}
        />
      </ImageWrapper>
    </ModalContent>
  );
};
